const initialState = {
  users: null,
  requests: [],
  sources: [],
  areas: [],
  unconformities: [],
  desNons: [],
  additionalDes: [],
  reasons: [],
  brand: [],
  packagesBeer: [],
  beers: [],
  usersList: [],
  reportsPZ05: [],
  bins: [],
  reportPZ04: [],
  topic: [],
  repairOrders: [],
  events: [],
  microbiology: [],
  specifications: [],
  rn_fiz1: [],
};

export default initialState;
